module.exports = __webpack_public_path__ + "img/logo.308b6788.png";